import { Route, Routes, useLocation } from 'react-router';
import RedirectTo from './RedirectTo';
import NotFound from './components/blocks/NotFound';
import CenteredLayout from './components/layouts/CenteredLayout';
import OrganizationLayout from './components/layouts/OrganizationLayout';
import { useUser } from './contexts/UserSession';
import GroupDetail from './pages/GroupDetails';
import Groups from './pages/Groups';
import InvitationPage from './pages/Invitation';
import LeadDetailsPage from './pages/LeadDetails';
import LeadsPage from './pages/Leads';
import LoginPage from './pages/LoginPage';
import MSALCallback from './pages/LoginPage/MSAL/MSALCallback';
import OIDCCallback from './pages/LoginPage/OIDC/OIDCCallback';
import NewLeadsPage from './pages/NewLeads';
import OrganizationPage from './pages/Organization';
import ProfilePage from './pages/ProfilePage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SignOutPage from './pages/SignOutPage';
import SubscribeEmailPage from './pages/SubscribeEmail';
import UnsubscribeEmailPage from './pages/UnsubscribeEmail';
import Users from './pages/Users';
import runtime from './runtime';

const AppRoutes = () => {
    const user = useUser();
    const location = useLocation();

    if (!runtime.organization) {
        return <NotFound homePath={null} />;
    }

    const invitationRoute = (
        <Route element={<CenteredLayout />} path="/invitation/*">
            <Route element={<InvitationPage />} index />
            <Route element={<NotFound homePath="/invitation/" />} path="*" />
        </Route>
    );

    const emailRoute = (
        <Route element={<CenteredLayout />} path="/email/*">
            <Route element={<SubscribeEmailPage />} path="subscribe" />
            <Route element={<UnsubscribeEmailPage />} path="unsubscribe" />
            <Route element={<NotFound homePath="/email/" />} path="*" />
        </Route>
    );

    if (!user) {
        return (
            <Routes>
                {invitationRoute}
                {emailRoute}
                <Route element={<CenteredLayout />} path="/login/*">
                    <Route element={<LoginPage />} index />
                    <Route element={<ResetPasswordPage />} path="resetPassword" />
                    <Route element={<MSALCallback />} path="sso/msal" />
                    <Route element={<OIDCCallback />} path="sso/oidc" />
                    <Route element={<NotFound homePath="/login/" />} path="*" />
                </Route>
                <Route
                    element={<RedirectTo state={{ from: location.pathname, fromState: location.state }} to="/login/" />}
                    path="*"
                />
            </Routes>
        );
    }

    return (
        <Routes>
            <Route element={<RedirectTo to="/" />} path="/login/*" />
            {invitationRoute}
            {emailRoute}
            <Route element={<OrganizationLayout />} path="*">
                <Route element={<RedirectTo to="/leads" />} index />
                <Route element={<LeadsPage />} path="leads" />
                <Route element={<NewLeadsPage />} path="leads/new" />
                <Route element={<LeadDetailsPage />} path="leads/:id" />
                <Route element={<OrganizationPage />} path="organization" />
                <Route element={<Users />} path="users" />
                <Route element={<Groups />} path="groups" />
                <Route element={<GroupDetail />} path="groups/:id" />
                <Route element={<ProfilePage />} path="profile" />
                <Route element={<SignOutPage />} path="signout" />
                <Route element={<NotFound homePath="/" />} path="*" />
            </Route>
        </Routes>
    );
};

export default AppRoutes;
